import { environment } from "../../../environments/environment";

export const IMAGES_URL = environment.staticApi;

export const BASE_API = environment.serverURL + "/api";
export const API = BASE_API + "/common";

export const CURRENT_PLATFORM_API_URL = API + "/statics/platform";

export const AVAILABILITY_STREAMING_URL = "https://streamer.algebratec.com"

export const STREAM_AVAILABILITY_API_URL = AVAILABILITY_STREAMING_URL + "/availability";